module.exports = __webpack_public_path__ + "static/media/Kristalina_desktop.68a01ce7.jpg";